import { type CSSProperties, type PropsWithChildren } from 'react';

// display: contents keeps the wrapper out of layout; Datadog's recorder still applies the
// privacy attribute to all descendants.
const noLayoutImpact: CSSProperties = { display: 'contents' };

// Masks all rendered text in session replay for the subtree. Customer-facing pages show PII
// (names, addresses, balances) as plain text, which the app-wide 'mask-user-input' privacy
// level does not cover — it only masks typed input.
export function ReplayPrivacyMask({ children }: PropsWithChildren) {
  return (
    <div data-dd-privacy="mask" style={noLayoutImpact}>
      {children}
    </div>
  );
}
